import { Link } from "./link.model"
import { Invoice } from "./invoice.model"
import { Address } from "./address.model"
import { OpenItemPayment } from "./open-item-payment.model"

export class OpenItem {
	merchantId: string
	uuid: string
	orderUUID: string;
	orderNumber: string
	checkoutRef: string;
	customerFullName: string
	invoice: Invoice
	missingValue: string
	paymentValue: string
	payments: OpenItemPayment[]
	invoideAddress: Address
	invoiceCorrections: InvoiceCorrection[];
	_links: {
		self: Link
		openItem: Link
	}
}

export class InvoiceCorrection {
	id: number;
	uuid: string;
	invoiceCorrectionNumber: string;
	invoiceCorrectionDate: string;
	value: number;
	correctionPositions: any[];
}



// WEBPACK FOOTER //
// ./src/app/models/open-item.model.ts